import {
  LOYALTY_POINTS_FAILED,
  LOYALTY_POINTS_SUCCESS,
  LOYALTY_POINTS_INVALID_REQUEST,
  NETWORK_ERROR_LOYALTY_POINTS,
  RESET_LOYALTY_POINTS,
  LOADING_LOYALTY
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  networkError: "",
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_LOYALTY:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        networkError: "",
        data: {}
      };
    case LOYALTY_POINTS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: true,
        networkError: "",
        data: action.payload
      };
    case LOYALTY_POINTS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        networkError: "",
        data: action.payload
      };
    case LOYALTY_POINTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: action.payload
      };

    case NETWORK_ERROR_LOYALTY_POINTS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        networkError: "Something went wrong.."
      };

    case RESET_LOYALTY_POINTS:
      return (state = initialState);

    default:
      return state;
  }
};
